<template>
  <div class="app-container">
    <el-card>
      <!--      <el-select v-model="curTimeRange">-->
      <!--        <el-option v-for="item in timeRangeOption" :value="item.value" :key="item.value"-->
      <!--                   :label="item.label"></el-option>-->
      <!--      </el-select>-->

      <!--时间段-->
      <el-date-picker v-model="startDate" style="margin-left: 20px" placeholder="开始时间" :clearable="false"
                      value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd"
                      :picker-options="startTimePickerOptions" @change="onStartTimeChange()"></el-date-picker>
      <span style="margin-left: 10px">-</span>
      <el-date-picker v-model="endDate" :disabled="!startDate" style="margin-left: 10px" :clearable="false"
                      placeholder="结束时间" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd"
                      :picker-options="endTimePickerOptions" @change="onEndDateChange()"></el-date-picker>

      <!--      <el-button type="success" size="small">导出excel</el-button>-->
    </el-card>

    <el-card>
      <div class="topbar">
        <!--统计数据类型-->
        <el-button-group>
          <el-tooltip v-for="item in dataTypeOptions"
                      :content="item.tipsText">
            <el-button :disabled="getDataTypeDisable(item.value)" size="small"
                       :type="curDataType === item.value ? 'primary' : ''"
                       @click="onDataTypeChange(item.value)">{{ item.label }}
            </el-button>
          </el-tooltip>
        </el-button-group>
        <!--        <el-radio-group v-model="curDataType" @change="onDataTypeChange()" size="small">-->
        <!--          <el-radio-button v-for="item in dataTypeOptions" :label="item.value" :key="item.value">{{ item.label }}-->
        <!--          </el-radio-button>-->
        <!--        </el-radio-group>-->
        <!--时间单位选择-->
        <el-button-group>
          <el-tooltip v-for="item in timeUnitOptions"
                      :content="item.tipsText">
            <el-button :disabled="getTimeUnitDisable(item.value)" size="small"
                       :type="curTimeUnit === item.value ? 'primary' : ''"
                       @click="onTimeUnitChange(item.value)">{{ item.label }}
            </el-button>
          </el-tooltip>
        </el-button-group>
        <!--                  <el-radio-group v-model="curTimeUnit" @change="onTimeUnitChange()" size="small">-->
        <!--                    <el-radio-button v-for="item in timeUnitOptions" :label="item.value" :key="item.value">{{ item.label }}-->
        <!--                    </el-radio-button>-->
        <!--                  </el-radio-group>-->

      </div>

      <!--图表控件-->
      <div id="chartElement" v-loading="loading"></div>
      <!--图表类型-->
      <el-radio-group v-model="curChartType" @change="onChartTypeChange()" size="small">
        <el-radio-button v-for="item in chartTypeOptions" :label="item.value" :key="item.value">{{ item.label }}
        </el-radio-button>
      </el-radio-group>
    </el-card>


  </div>
</template>

<script>
import {getUserDataStatistics} from "@/api/statisticsManagement/statisticalData";
import {handleResWithReturn} from "@/utils/handleRes";
import {addDateTime, DateTimeField, getTimeFromString} from "@/utils/DateUtils";
import {isVaild} from "@/utils/validate";
import {getNavigationItemObj, setNavigationItemWithObj} from "@/utils/NavigationUtils";

export default {
  name: "UserDataStatistics",
  created() {
    let navigationItemObj = getNavigationItemObj(this.navigationKey)
    this.curDataType = navigationItemObj.dataType ?? 0
    this.curTimeUnit = navigationItemObj.timeUnit ?? 1
    this.curChartType = navigationItemObj.chartType ?? 0
    let endTime = getTimeFromString(`${new Date().format("yyyy-MM-dd")} 23:59:59`)

    this.endDate = new Date(endTime).format("yyyy-MM-dd HH:mm:ss");

    this.startDate = new Date(addDateTime(addDateTime(endTime, DateTimeField.Month, -1), DateTimeField.Second, 1)).format("yyyy-MM-dd HH:mm:ss")
    // this.startDate = new Date(addDateTime(endTime, DateTimeField.Month, -1)).format("yyyy-MM-dd HH:mm:ss")
    if (isVaild(navigationItemObj.startDate) && isVaild(navigationItemObj.endDate)) {
      this.startDate = navigationItemObj.startDate
      this.endDate = navigationItemObj.endDate
    }
    this.refreshData();
  },
  data() {
    return {
      navigationKey: "userDataStatistics",

      curTimeRange: 0,
      //获取的数据时间范围 0-三个月之内 1-一年之内 2- 三年之内 3- 所有 默认0
      timeRangeOption: [
        {value: 0, label: "三个月之内"},
        {value: 1, label: "一年之内"},
        {value: 2, label: "三年之内"},
        {value: 3, label: "所有"},
      ],
      curDataType: 0,
      //0-新增用户 1-活跃用户 2-累计登录次数 3-用户累计数目
      dataTypeOptions: [
        {value: 0, label: "新增用户", tipsText: "可查看所有数据"},
        {value: 1, label: "活跃用户", tipsText: "只能查询3个月内数据"},
        {value: 2, label: "累积登录次数", tipsText: "只能查询3个月内数据"},
        {value: 3, label: "用户累积数目", tipsText: "可查看所有数据"}
      ],
      curTimeUnit: 1,
      // 时间单位 0-小时 1-天 2-周 3-月 4-年 默认是天
      // 注意使用小时范围不能超过7天，
      // 使用天不能超过1个月，
      // 使用周不能超过三个月,
      // 使用月为单位查询时间间隔不能大于1年,
      // 使用年为单位查询时间间隔不能大于3年
      timeUnitOptions: [
        {value: 0, label: "时", tipsText: "使用小时为单位查询时间间隔不能大于7天"},
        {value: 1, label: "天", tipsText: "使用天为单位查询时间间隔不能大于1个月"},
        {value: 2, label: "周", tipsText: "使用周为单位查询时间间隔不能大于3个月"},
        {value: 3, label: "月", tipsText: "使用月为单位查询时间间隔不能大于1年"},
        {value: 4, label: "年", tipsText: "使用年为单位查询时间间隔不能大于10年"},
      ],

      startTimePickerOptions: {
        disabledDate: (time) => {
          let nowDateTime = getTimeFromString(`${new Date().format('yyyy-MM-dd')} 23:59:59`)
          if (this.curDataType === 3 || this.curDataType === 0) {//用户累积数目和新增用户数可以不限制时间范围
            let startTime = addDateTime(nowDateTime, DateTimeField.Year, -10)
            //三年-现在
            return time.getTime() > nowDateTime || time.getTime() < startTime
          }
          //其他项目限制在3个月范围内
          let startTime = addDateTime(nowDateTime, DateTimeField.Month, -3)
          //三月-现在
          return time.getTime() < startTime || time.getTime() > nowDateTime
        }
      },
      endTimePickerOptions: {
        disabledDate: (time) => {
          //console.log(`endTimePickerOptions disabledDate startDate ${this.startDate}`)
          let endTime = this.getEndTimeFromStartDate();
          //.log(`endTimePickerOptions startTime ${new Date(startTime)} endTime ${new Date(endTime)}`)
          //根据时间单位和开始时间决定
          return time.getTime() < getTimeFromString(this.startDate) || time.getTime() > endTime
        }
      },

      loading: false,
      startDate: "",
      endDate: "",
      statisticsData: [],

      chartElement: null,
      chartDrawOption: null,

      curChartType: 0,
      chartTypeOptions: [
        {value: 0, label: "折线图", type: "line"},
        {value: 1, label: "柱状图", type: "bar"},
        // {value: 2, label: "饼图", type: "pie"},
      ]
    }
  },
  methods: {
    /**
     * 根据startDate判断哪些dataTypeOption可用
     * 只有用户累积数目支持超过三个月数据查询
     * @param dataType
     * @returns {boolean}
     */
    getDataTypeDisable(dataType) {
      let nowDateTime = getTimeFromString(`${new Date().format('yyyy-MM-dd')} 23:59:59`)
      if (dataType === 3 || dataType === 0) {//新增用户、用户累积数目可以不限制时间范围
        return false
      }
      //其他项目限制在3个月范围内
      let startTime = addDateTime(nowDateTime, DateTimeField.Month, -3)
      return getTimeFromString(this.startDate) < startTime
    },
    /**
     * 根据startDate和endDate判断哪些TimeUnit可用，不同的TimeUnit有不同的时间段要求
     * @param timeUnit
     * @returns {boolean}
     */
    getTimeUnitDisable(timeUnit) {
      let endTime = this.getEndTimeFromStartDate(timeUnit);
      //console.log(`getTimeUnitDisable ${timeUnit} ${this.startDate} ${this.endDate} ${new Date(endTime).format('yyyy-MM-dd hh:mm:ss')} ${getTimeFromString(this.endDate) > endTime}`)
      if (getTimeFromString(this.endDate) > endTime) {
        return true
      }
      return false
    },
    /**
     * 根据选择的startDate和时间单位，计算endTime
     * @returns {number}
     */
    getEndTimeFromStartDate(timeUnit = this.curTimeUnit) {
      let startTime = new Date(this.startDate).getTime()
      let endTime;
      switch (timeUnit) {
        case 0://时，不能超过7天，
          endTime = addDateTime(startTime, DateTimeField.Day, 7)
          break;
        case 1://天，不能超过1个月，
          endTime = addDateTime(startTime, DateTimeField.Month, 1)
          break;
        case 2://周，不能超过三个月,
          endTime = addDateTime(startTime, DateTimeField.Month, 3)
          break;
        case 3://月，不能大于1年,
          endTime = addDateTime(startTime, DateTimeField.Year, 1)
          break;
        case 4://年，不能大于10年
          endTime = addDateTime(startTime, DateTimeField.Year, 10)
          break;
        default:
          endTime = addDateTime(startTime, DateTimeField.Month, 1)
          break;
      }
      //addDateTime运算后（startTime 08-09 endTime 09-09），需要-1s才在时间范围内
      endTime = Math.min(addDateTime(endTime, DateTimeField.Second, -1), getTimeFromString(`${new Date().format('yyyy-MM-dd')} 23:59:59`))
      return endTime;
    },
    /**
     * 统计类型改变
     */
    onDataTypeChange(dataType) {
      this.curDataType = dataType
      this.refreshData();
    },
    /**
     * 统计时间单位改变
     */
    onTimeUnitChange(timeUnit) {
      this.curTimeUnit = timeUnit
      this.refreshData();
    },
    /**
     * 绘制图表类型改变
     */
    onChartTypeChange() {
      this.drawChat()
    },
    /**
     * 统计开始时间改变，还要联动endDate
     */
    onStartTimeChange() {
      this.endDate = new Date(this.getEndTimeFromStartDate());
      this.refreshData()
    },
    /**
     * 统计结束时间改变，查询数据
     */
    onEndDateChange() {
      this.refreshData()
    },
    /**
     * 调用接口，查询数据
     * @returns {Promise<void>}
     */
    async refreshData() {
      let res = await this.getUserDataStatistics();
      if (isVaild(res)) {
        this.statisticsData = res
      } else {
        this.statisticsData = []
      }
      this.drawChat();
    },
    /**
     * 获取图表标题
     * 不同的数据类型对应不同的标题
     * @returns {string|*}
     */
    getChartTitle() {
      return this.dataTypeOptions[this.curDataType].label
    },
    /**
     * 图表X轴标题
     * @returns {string[]}
     */
    getXAxisData() {
      return this.statisticsData.map(item => {
        return `${item.time}`
      })

    },
    /**
     * 图表对应的Y轴数据
     * @returns {*[]}
     */
    getSeriesData() {
      return this.statisticsData.map(item => {
        return item.count
      })
    },
    /**
     * 折线图样式
     * @returns {{yAxis: {minInterval: number, type: string}, xAxis: {axisLabel: {rotate: number, show: boolean, interval: number}, data: string[], type: string}, grid: {top: string, left: string, bottom: string, right: string, containLabel: boolean}, series: [{areaStyle: {}, data: *[], itemStyle: {normal: {color: string}}, type: string}], tooltip: {axisPointer: {type: string}, trigger: string}, title: {top: string, x: string, text: (string|*)}}}
     */
    getChartLineDrawOption() {
      return {
        title: {
          text: this.getChartTitle(),
          x: 'center',
          top: '5%'
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          top: '15%',
          left: '2%',
          right: '2%',
          bottom: '5%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: this.getXAxisData(),
          axisLabel: {
            // x轴文字的配置
            show: true,
            interval: 0,// 使x轴文字显示全
            rotate: 35
          }
        },
        yAxis: {
          type: 'value',
          minInterval: 1
        },
        series: [
          {
            data: this.getSeriesData(),
            type: 'line',
            areaStyle: {},
            itemStyle: {
              normal: {
                color: '#409EFF'
              }
            }
          }
        ]
      }
    },
    /**
     * 柱状图样式
     * @returns {{yAxis: {minInterval: number}, xAxis: {data: string[]}, series: [{data: *[], itemStyle: {normal: {color: string}}, type: string}], tooltip: {}, title: {text: (string|*)}}}
     */
    getChartBarDrawOption() {
      return {
        title: {
          text: this.getChartTitle()
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        xAxis: {
          data: this.getXAxisData(),
          axisLabel: {
            // x轴文字的配置
            show: true,
            interval: 0,// 使x轴文字显示全
            rotate: 35
          }
        },
        yAxis: {
          minInterval: 1
        },
        series: [
          {
            type: 'bar',
            data: this.getSeriesData(),
            itemStyle: {
              normal: {
                color: '#409EFF'
              }
            }
          }
        ]
      }
    },
    /**
     * 饼状图样式
     * @returns {{legend: {orient: string, top: string, data: string[], left: string}, series: [{data: {name: *, value: *}[], center: string[], name: string, emphasis: {itemStyle: {shadowOffsetX: number, shadowBlur: number, shadowColor: string}}, type: string, radius: string}], tooltip: {formatter: string, trigger: string}, title: {top: string, left: string, text: (string|*)}}}
     */
    getChartPieDrawOption() {
      return {
        title: {
          text: this.getChartTitle(),
          left: 'center',
          top: '20'
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },
        legend: {
          orient: 'vertical',
          left: '20',
          top: '20',
          data: this.getXAxisData()
        },
        series: [
          {
            name: '访问来源',
            type: 'pie',
            radius: '55%',
            center: ['50%', '60%'],
            data: this.statisticsData.map(item => {
              return {value: item.count, name: item.time}
            }),
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      }
    },
    /**
     * 绘制图表
     */
    drawChat() {
      if (!isVaild(this.chartElement)) {
        this.chartElement = this.$echarts.init(
            document.getElementById('chartElement')
        )
      }
      this.chartElement.resize()
      switch (this.curChartType) {
        case 0://折线图
          this.chartDrawOption = this.getChartLineDrawOption()
          break;
        case 1://柱状图
          this.chartDrawOption = this.getChartBarDrawOption()
          break;
        case 2://饼图
          this.chartDrawOption = this.getChartPieDrawOption()
          break;
      }
      this.chartElement.setOption(this.chartDrawOption)
    },
    /**
     * 根据开始时间自动转换timeRange
     */
    transformTimeRange() {
      let nowTime = getTimeFromString(`${new Date().format("yyyy-MM-dd")} 23:59:59`)
      let startTime = getTimeFromString(this.startDate);

      if (startTime <= addDateTime(nowTime, DateTimeField.Year, -3)) {
        // console.log('所有')
        this.curTimeRange = 3
      } else if (startTime <= addDateTime(nowTime, DateTimeField.Year, -1)) {
        // console.log('三年内')
        this.curTimeRange = 2
      } else if (startTime <= addDateTime(nowTime, DateTimeField.Month, -3)) {
        // console.log('一年内')
        this.curTimeRange = 1
      } else {
        // console.log('三月内')
        this.curTimeRange = 0;
      }
    },
    /**
     * 服务接口
     * @returns {Promise<null|*>}
     */
    async getUserDataStatistics() {
      let param = {
        timeRange: this.curTimeRange,
        type: this.curDataType,
        timeUnit: this.curTimeUnit,
      }

      if (isVaild(this.startDate)) {
        console.log(`startTime ${this.startDate}`)
        param.startTime = getTimeFromString(this.startDate)
      }

      if (isVaild(this.endDate)) {
        console.log(`endTime ${this.endDate}`)
        param.endTime = getTimeFromString(`${new Date(this.endDate).format('yyyy-MM-dd')} 23:59:59`)
      }

      this.transformTimeRange();

      setNavigationItemWithObj(this.navigationKey, {
        timeUnit: this.curTimeUnit,
        dataType: this.curDataType,
        chartType: this.curChartType,
        startDate: this.startDate,
        endDate: this.endDate
      })

      this.loading = true;
      let res = await getUserDataStatistics(param)
      this.loading = false;
      if (handleResWithReturn(res)) {
        return res.data
      }
      return null;
    }
  }
}
</script>

<style scoped>
#chartElement {
  width: 100%;
  height: 330px;
}
</style>